import "../sass/main.scss";

import "slick-carousel/slick/slick";
import "./jquery.vnm.percentWithinViewport.min";

import "./script-modal";
import "./script-patterns";

import "./woocommerce";

import "./jquery-svgmaps";
import "./interactive-map";

function is_touch_device(){
    try{
        document.createEvent("TouchEvent");
        return true;
    } catch(e){
        return false;
    }
}

function isInvisibleInWindow(elem,offset=0){
    var $elem = jQuery(elem);
    var $window = jQuery(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();

    return ((elemTop >= docViewBottom) || ((elemBottom + offset) <= docViewTop));
}

function stickyTop(){
    var $stickyContainer = jQuery('.sticky-top');
    var $padding = jQuery('.sticky-top').height();

    var $window = jQuery(window);
    var $docViewTop = $window.scrollTop();

    if( $stickyContainer.length > 0 )
    {
        if(isInvisibleInWindow($stickyContainer, 100)) jQuery('body').addClass('active-sticky-top').css('padding-top',$padding);
        else if( $docViewTop == 0 ) jQuery('body').removeClass('active-sticky-top').css('padding-top',0);
    }
}

function activeSection(){
    jQuery('.section').each(function(){
        if( !isInvisibleInWindow(jQuery(this)) ) jQuery(this).addClass('active-section').addClass('temp-active-section');
        else jQuery(this).removeClass('temp-active-section');
    });
}

function stickToSides(){
    let maxWidth = 2300;
    let $window = jQuery(window);

    jQuery('.stickToLeft').each(function(){
        let offset = jQuery(this).offset().left;
        let width = jQuery(this).width();
        var left = offset;

        if( $window.width() < maxWidth )
            jQuery(this).css('margin-left',-offset);
        else
            jQuery(this).css('margin-left','');

        jQuery(this).width( width + left ) ;
    });

    jQuery('.stickToRight').each(function(){
        let offset = jQuery(this).offset().left;
        let width = jQuery(this).width();
        var right = $window.width() - ( offset + width )

        if( $window.width() < maxWidth )
            jQuery(this).css('margin-right',-right);
        else
            jQuery(this).css('margin-right','');

        jQuery(this).width( width + right ) ;
    });
}

function imgParallax(){
    jQuery('.section-head-image img, .parallax img').percentWithinViewport();
    jQuery('.section-head-image img, .parallax img').each(function(){
        var el = jQuery(this);

        var translateY = 0;
        if( el.offset().top < jQuery(window).scrollTop() ) {
            var percent = el.attr('data-percent-viewport');
            translateY = (100 - percent) / 2;
        }

        el.css({
            '-webkit-transform': 'translateY(' + translateY + '%)',
            '-moz-transform': 'translateY(' + translateY + '%)',
            '-ms-transform': 'translateY(' + translateY + '%)',
            '-o-transform': 'translateY(' + translateY + '%)',
            'transform': 'translateY(' + translateY + '%)'
        });
    });
}

function imgScaleOn(){
    jQuery('.img-scale-on img').percentWithinViewport();
    jQuery('.img-scale-on img').each(function(){
        var el = jQuery(this);

        if( el.offset().top > jQuery(window).scrollTop() ){
            var percent = el.attr('data-percent-viewport');
            var scale = 1 + (1 - percent/100);

            el.css({
                '-webkit-transform' : 'scale(' + scale + ')',
                '-moz-transform'    : 'scale(' + scale + ')',
                '-ms-transform'     : 'scale(' + scale + ')',
                '-o-transform'      : 'scale(' + scale + ')',
                'transform'         : 'scale(' + scale + ')'
            })
        }
    });
}


// EVENTS : CHARGEMENT DU DOCUMENT
jQuery(document).ready(function() {

    // > Accessibility
    jQuery('.pojo-a11y-toolbar-toggle').hide();

    jQuery('.js-accessibility').click(function (event) {
        event.preventDefault();

        if (jQuery(this).hasClass('active')) {
            jQuery(this).removeClass('active');
            jQuery('#pojo-a11y-toolbar').removeClass('pojo-a11y-toolbar--open');
            jQuery('.pojo-a11y-toolbar-link').click();
        } else {
            jQuery(this).addClass('active');
            jQuery('#pojo-a11y-toolbar').addClass('pojo-a11y-toolbar--open');
            jQuery('.pojo-a11y-toolbar-link').click();
        }
        // jQuery('.pojo-a11y-toolbar-toggle').show();
        // jQuery('#pojo-a11y-toolbar').css('left', '-250px !important');

        return false;
    });

    jQuery('.pojo-a11y-toolbar-toggle').click(function (event) {
        event.preventDefault();

        jQuery('.pojo-a11y-toolbar-toggle').hide();

        return false;
    });
    // < Accessibility

    // gestion du header fixe au scroll
    stickyTop();
    activeSection();

    // gestion des éléments ferrés
    stickToSides();

    // gestion du scroll vers une ancre
    document.querySelectorAll(':not( .tabs ):scope a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            if( this.getAttribute('href') != '#tarteaucitron' )
            {
                e.preventDefault();

                document.querySelector(this.getAttribute('href')).scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        });
    });

    // gestion des menus déroulants
    jQuery('.megamenu-col .menu-item-has-children').each(function () {
        let menu = jQuery(this).find('> a');
        let wrapper = menu.wrap('<div class="parent-menu"></div>').parent();

        let trigger = jQuery('<span class="sub-menu-trigger"></span>').appendTo(wrapper);
        trigger.click(function () {
            jQuery(this).toggleClass('active');
            jQuery(this).parent().next().slideToggle();
        });
    });

    // gestion des cards déroulantes
    jQuery('.toggle-title').click(function () {
        jQuery(this).toggleClass('active');
        jQuery(this).next('.toggle-content').slideToggle();
    });
    jQuery('.toggle-content').each(function () {
        jQuery(this).hide();
    });

    // > Modal
    const body = document.body;
    const buttons = document.querySelectorAll('.trigger[data-modal-trigger]');

    for (let button of buttons) {
        modalEvent(button);
    }

    function modalEvent(button) {
        button.addEventListener('click', () => {
            jQuery('.close').click();

            const trigger = button.getAttribute('data-modal-trigger');
            const modal = document.querySelector(`[data-modal=${trigger}]`);
            const contentWrapper = modal.querySelector('.content-wrapper');
            const close = modal.querySelector('.close');

            let modalTitle = button.getAttribute('data-modal-title');
            if (modalTitle) {
                contentWrapper.querySelector('.modal-header').innerHTML = modalTitle;
            }

            let modalContent = button.getAttribute('data-modal-content');
            if (modalContent) {
                contentWrapper.querySelector('.content').innerHTML = modalContent;
            }

            close.addEventListener('click', () => modal.classList.remove('open'));
            close.addEventListener('click', () => body.classList.remove('modal-open'));
            modal.addEventListener('click', () => modal.classList.remove('open'));
            contentWrapper.addEventListener('click', (e) => e.stopPropagation());

            modal.classList.toggle('open');
            body.classList.toggle('modal-open');
        });
    }
    // < Modal

    jQuery('<span class="widget_search__toggle"></span>').appendTo('.widget_search')
        .click(function(){
            jQuery('.wp-block-search__inside-wrapper').fadeToggle();
        });

    // slick
    jQuery('.slick').slick();
});

// EVENTS : SCROLL
jQuery(window).scroll(function() {
    stickyTop();
    activeSection();
    imgScaleOn();
    imgParallax();
});

// EVENTS : RESIZE
jQuery(window).resize(function() {
    stickToSides();
});

// permet d'utiliser le plugin responsive lightbox sur les media gallery VC
jQuery(document).ajaxComplete(function () {
    jQuery('.vc-prettyphoto-link').click(function () {
        return false;
    });
});
